import { LinearRange } from './linear_range';
import { DiscreteRange } from './discrete_range';

const TIME_RANGE = 'timeRange';
const MAP_TIME = 'mapTime';
const MAP_TIME_ACTIVE = 'mapTimeActive';

const LINEAR = 'LINEAR';
const DISCRETE = 'DISCRETE';

export {
	TIME_RANGE,
	MAP_TIME,
	MAP_TIME_ACTIVE,
	LinearRange,
	DiscreteRange,
	LINEAR,
	DISCRETE
}